module.exports = __webpack_public_path__ + "img/back1.32a21ab5.png";